import { PageLoader } from '../../PageLoader'
import { usePluralAuth } from '../../providers/PluralAuthProvider'
export default function RequireAuthStateToRender({ children }: any) {
  const { isLoading } = usePluralAuth()
  return isLoading ? <PageLoader /> : children
}
